import classes from "./DataNotFound.module.css";

const DataNotFound = () => {
  return (
    <div className={classes.dataNotFoundContainer}>
      <div>
        <div style={{ textAlign: "center" }}>
          <i className="fal fa-frown" style={{ fontSize: 55 }}></i>
        </div>
        <div style={{ textAlign: "center", marginTop: 10 }}>
          Không tìm thấy dữ liệu!
        </div>
      </div>
    </div>
  );
};

export default DataNotFound;
